import React from 'react'

const NoBuses = () => {
    return (
        <div className='text-xl text-center'>No Buses Found on Searched Route</div>
    )
}

export default NoBuses